import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIconInfoRoundedFilled = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 32 32" aria-hidden={!title && !titleId} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<g><path fill="currentColor" fillRule="evenodd" d="M16 0C7.16 0 0 7.16 0 16s7.16 16 16 16 16-7.16 16-16S24.84 0 16 0m1 23c0 .56-.44 1-1 1s-1-.44-1-1v-9.1c0-.56.44-1 1-1s1 .44 1 1zm-1-12.04c-.72 0-1.3-.6-1.3-1.3s.58-1.3 1.3-1.3 1.3.58 1.3 1.3-.58 1.3-1.3 1.3" clipRule="evenodd" /></g></svg>;
export default SvgIconInfoRoundedFilled;